import React from 'react';
import { connect } from 'react-redux';
import { DBCheckBoxObjective } from '_components';
import styles from './Common.module.css'

class SpecialTestRightingReactionsStrategy extends React.Component {

    render() {
        return (
            <div>
                <div className={styles.checkbox_row}>
                    <span className={styles.flag} />
                    <span className={styles.spacer} />
                    <span className={styles.label} />
                    <span className={styles.r} >
                        <DBCheckBoxObjective noteId={this.props.noteId} entity='PTOBJECTIVESPECTESTS' entityKeyColumn='TSNO' entityKeyValue={this.props.tsno} field='TSRRSANKLE' label='Ankle' className={styles.checkbox} />
                    </span>
                    <span className={styles.c} />
                    <span className={styles.l} >
                        <DBCheckBoxObjective noteId={this.props.noteId} entity='PTOBJECTIVESPECTESTS' entityKeyColumn='TSNO' entityKeyValue={this.props.tsno} field='TSRRSUE' label='UE' className={styles.checkbox} />
                    </span>
                </div>
                <div className={styles.checkbox_row}>
                    <span className={styles.flag} />
                    <span className={styles.spacer} />
                    <span className={styles.label} />
                    <span className={styles.r} >
                        <DBCheckBoxObjective noteId={this.props.noteId} entity='PTOBJECTIVESPECTESTS' entityKeyColumn='TSNO' entityKeyValue={this.props.tsno} field='TSRRSKNEE' label='Knee' className={styles.checkbox} />
                    </span>
                    <span className={styles.c} />
                    <span className={styles.l} >
                        <DBCheckBoxObjective noteId={this.props.noteId} entity='PTOBJECTIVESPECTESTS' entityKeyColumn='TSNO' entityKeyValue={this.props.tsno} field='TSRRSUNABLE' label='Unable' className={styles.checkbox} />
                    </span>
                </div>
                <div className={styles.checkbox_row}>
                    <span className={styles.flag} />
                    <span className={styles.spacer} />
                    <span className={styles.label} />
                    <span className={styles.r} >
                        <DBCheckBoxObjective noteId={this.props.noteId} entity='PTOBJECTIVESPECTESTS' entityKeyColumn='TSNO' entityKeyValue={this.props.tsno} field='TSRRSHIP' label='Hip' className={styles.checkbox} />
                    </span>
                    <span className={styles.c} />
                    <span className={styles.l} />
                </div>
            </div>
        );
    }
}

function mapStateToProps(state) {
    let noteId = state.ui.patientTabs[state.ui.patientCenter[state.ui.patients.selectedPtno].selectedTab].noteId;
    let noteType = parseInt(noteId.split("_")[0]);
    let pk = parseInt(noteId.split("_")[1]);
    let tsno = parseInt(Object.keys(state.entities.notes.PTOBJECTIVESPECTESTS)
        .find(key => (state.entities.notes.PTOBJECTIVESPECTESTS[key].TSEVNO === pk && noteType === 1)
            || (state.entities.notes.PTOBJECTIVESPECTESTS[key].TSNTNO === pk && noteType !== 1)));


    return {
        noteId: noteId,
        tsno: tsno
    };
}

const connectedSpecialTestRightingReactionsStrategy = connect(mapStateToProps)(SpecialTestRightingReactionsStrategy);
export { connectedSpecialTestRightingReactionsStrategy as SpecialTestRightingReactionsStrategy };



